
"use client";

import "./ClientTestimonialsSection.scss";
import { Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import Image from "next/image";

import "swiper/css";
import "swiper/css/autoplay";

const ClientTestimonialsSection = ({
  title,
  highlightTitle,
  description,
  testimonialsData = [],
  className = "",
  background = "white",
}) => {
  return (
    <section
      className={`client-testimonials-section bg-${background} ${className}`}
    >
      <div className="blur-bg" />

      <Container>
        <div className="section-heading">
          <h2 className="testi-title">
            {title}{" "}
            {highlightTitle && (
              <span>{highlightTitle}</span>
            )}
          </h2>

          {description && (
            <p className="testi-description">
              {description}
            </p>
          )}
        </div>

        <div className="testimonials-swiper">
          <Swiper
            modules={[Autoplay]}
            spaceBetween={24}
            slidesPerView={3}
            loop={testimonialsData.length > 3}
            speed={700}
            autoplay={{
              delay: 3500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            allowTouchMove
            grabCursor
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 16,
              },
              576: {
                slidesPerView: 1,
                spaceBetween: 18,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              992: {
                slidesPerView: 2,
                spaceBetween: 24,
              },
              1200: {
                slidesPerView: 3,
                spaceBetween: 24,
              },
            }}
          >
            {testimonialsData.map((item) => (
              <SwiperSlide key={item.company || item.name}>
                <article className="testi-card">
                  <div className="testimonial-quote-icon" aria-hidden="true">
                    “
                  </div>

                  <div className="testimonial-logo-wrapper">
                    <Image
                      src={item.image?.src || item.image}
                      alt={`${item.company || item.name} logo`}
                      width={180}
                      height={80}
                      sizes="(max-width: 575px) 160px, 180px"
                      className="testimonial-logo"
                    />
                  </div>

                  <div className="testimonial-card-divider" />

                  <h3 className="customer-name">
                    {item.company || item.name}
                  </h3>

                  <p className="customer-description">
                    {item.description}
                  </p>

                  <div className="testimonial-card-footer">
                    <span className="testimonial-footer-line" />
                    <span className="testimonial-footer-label">
                      Client Experience
                    </span>
                  </div>
                </article>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </Container>
    </section>
  );
};

export default ClientTestimonialsSection;
